import { API_ENDPOINT, isServerApiError, Logger } from "@cede/utils";
import { apiHelper } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export type SystemMetadataFactory = {
  name: string;
  uiName: string;
  logo?: string;
  chainId?: string;
  address?: string;
};

export type SystemMetadataChain = {
  name: string;
  chainId?: string;
  logo?: string;
};

export type SystemMetadata = {
  poolTypes: string[];
  factories: SystemMetadataFactory[];
  chains: SystemMetadataChain[];
};

const fetchSystemMetadata = async (): Promise<SystemMetadata> => {
  const result = await apiHelper.get(API_ENDPOINT.ONCHAIN_SWAP_SYSTEM_METADATA);

  if (isServerApiError(result)) {
    Logger.error("Failed to fetch system metadata:", result);
    throw new Error("Failed to fetch system metadata");
  }

  return result;
};

export const useSystemMetadata = () => {
  return useQuery({
    queryKey: ["system-metadata"],
    queryFn: fetchSystemMetadata,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours - matches backend cache
  });
};
